import { useEffect } from 'react';

import { POLL_CONNECT_TO_SUBSCRIPTION_INTERVALS } from 'src/constants/commonConstants';

import type { ConnectSubscriptionStatus } from '../types/subscription.types';

export const getUsePollConnectFlow =
  (nodeStatus: ConnectSubscriptionStatus[], maxRetries?: number) =>
  (args: { currentNodeStatus?: ConnectSubscriptionStatus; callbackFn: () => void }) => {
    const { currentNodeStatus, callbackFn } = args;
    const maxRetriesCounter = { current: 0 };

    useEffect(() => {
      let isMounted = true;
      const timerId = { id: 0 };
      clearTimeout(timerId.id);

      if (currentNodeStatus && nodeStatus?.includes(currentNodeStatus)) {
        callbackFn();

        timerId.id = window.setInterval(() => {
          if (maxRetries && maxRetries === maxRetriesCounter.current) {
            clearTimeout(timerId.id);
          }

          if (isMounted) {
            callbackFn();
          }

          maxRetriesCounter.current = maxRetriesCounter.current + 1;
        }, POLL_CONNECT_TO_SUBSCRIPTION_INTERVALS);
      } else {
        clearTimeout(timerId.id);
      }

      return () => {
        clearTimeout(timerId.id);
        isMounted = false;
      };
    }, [currentNodeStatus]);
  };
